export function PaperPlaneIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2527 0.478026C18.3133 -0.380555 20.3806 1.68666 19.522 3.74726L13.5985 17.9637C12.44 20.744 8.3652 20.274 7.87004 17.3031L7.13103 12.869L2.69694 12.13C-0.274043 11.6348 -0.743981 7.55999 2.0363 6.40154L16.2527 0.478026ZM17.6758 2.97803C17.8475 2.56591 17.4341 2.15246 17.022 2.32418L2.80553 8.2477C1.87877 8.63385 2.03541 9.99211 3.02574 10.1572L7.45982 10.8962C8.30277 11.0367 8.96332 11.6972 9.10381 12.5402L9.84283 16.9743C10.0079 17.9646 11.3661 18.1212 11.7523 17.1945L17.6758 2.97803Z"
        fill="#B1B5C4"
      />
    </svg>
  );
}
export function HandCartIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.10182 12.1852C2.4598 11.8272 3.0402 11.8272 3.39818 12.1852L6.41667 15.2037C6.77465 15.5616 6.77465 16.142 6.41667 16.5C6.05869 16.858 5.47829 16.858 5.12031 16.5L2.10182 13.4815C1.74384 13.1236 1.74384 12.5432 2.10182 12.1852Z"
        fill="#B1B5C3"
      />
      <path
        d="M19.9235 5.20511C20.2669 4.83311 20.2437 4.25318 19.8717 3.90979C19.4997 3.5664 18.9198 3.5896 18.5764 3.9616L8.19814 15.2047C7.85475 15.5767 7.87795 16.1566 8.24996 16.5C8.62196 16.8434 9.20189 16.8202 9.54528 16.4482L15.8729 9.59333C16.0494 9.40205 16.3497 9.39605 16.5337 9.58012L17.6852 10.7315C18.0431 11.0895 18.6235 11.0895 18.9815 10.7315C19.3395 10.3736 19.3395 9.79315 18.9815 9.43517L17.7523 8.20597C17.5784 8.03202 17.5728 7.75177 17.7396 7.57101L19.9235 5.20511Z"
        fill="#B1B5C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.38879 11.8055L3.77788 10.1945C2.70393 9.12061 2.70393 7.3794 3.77788 6.30546L7.22212 2.86121C8.29607 1.78727 10.0373 1.78727 11.1112 2.86121L12.7221 4.47212C13.7961 5.54607 13.7961 7.28727 12.7221 8.36121L9.27787 11.8055C8.20393 12.8794 6.46273 12.8794 5.38879 11.8055ZM5.07424 8.89819L6.68515 10.5091C7.04313 10.8671 7.62353 10.8671 7.98151 10.5091L11.4258 7.06485C11.7837 6.70687 11.7837 6.12647 11.4258 5.76849L9.81485 4.15758C9.45686 3.79959 8.87646 3.79959 8.51849 4.15757L5.07424 7.60182C4.71626 7.9598 4.71626 8.5402 5.07424 8.89819Z"
        fill="#B1B5C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33334 18.3334C7.8396 18.3334 8.25 17.9229 8.25 17.4167C8.25 16.9104 7.8396 16.5 7.33334 16.5C6.82708 16.5 6.41667 16.9104 6.41667 17.4167C6.41667 17.9229 6.82708 18.3334 7.33334 18.3334ZM7.33334 20.1667C8.85212 20.1667 10.0833 18.9355 10.0833 17.4167C10.0833 15.8979 8.85212 14.6667 7.33334 14.6667C5.81455 14.6667 4.58334 15.8979 4.58334 17.4167C4.58334 18.9355 5.81455 20.1667 7.33334 20.1667Z"
        fill="#B1B5C3"
      />
    </svg>
  );
}
export function PinIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SearchIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9056 14.3199C11.551 15.3729 9.84871 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12.9056 14.3199ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SearchIcon2() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="#F7F7F7" />
      <ellipse
        cx="9.80549"
        cy="9.8055"
        rx="7.49047"
        ry="7.49047"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0153 15.4043L17.9519 18.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AvatarIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 13C8.13401 13 5 16.134 5 20V22C5 22.5523 4.55228 23 4 23C3.44772 23 3 22.5523 3 22V20C3 15.0294 7.02944 11 12 11C16.9706 11 21 15.0294 21 20V22C21 22.5523 20.5523 23 20 23C19.4477 23 19 22.5523 19 22V20C19 16.134 15.866 13 12 13Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11ZM12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13Z"
        fill="white"
      />
    </svg>
  );
}

export function GlobeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 8.00001C13.3333 5.05449 10.9455 2.66668 7.99998 2.66668C5.05446 2.66668 2.66665 5.05449 2.66665 8.00001C2.66665 10.9455 5.05446 13.3333 7.99998 13.3333ZM7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 8.00001C14.6666 4.31811 11.6819 1.33334 7.99998 1.33334C4.31808 1.33334 1.33331 4.31811 1.33331 8.00001C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667Z"
        fill="#777E91"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16447 12.1178C9.65694 11.1328 10 9.67885 10 8.00001C10 6.32117 9.65694 4.86719 9.16447 3.88225C8.63213 2.81756 8.14339 2.66668 8.00002 2.66668C7.85665 2.66668 7.36791 2.81756 6.83557 3.88225C6.3431 4.86719 6.00002 6.32117 6.00002 8.00001C6.00002 9.67885 6.3431 11.1328 6.83557 12.1178C7.36791 13.1825 7.85665 13.3333 8.00002 13.3333C8.14339 13.3333 8.63213 13.1825 9.16447 12.1178ZM8.00002 14.6667C9.84097 14.6667 11.3334 11.6819 11.3334 8.00001C11.3334 4.31811 9.84097 1.33334 8.00002 1.33334C6.15907 1.33334 4.66669 4.31811 4.66669 8.00001C4.66669 11.6819 6.15907 14.6667 8.00002 14.6667Z"
        fill="#777E91"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6337 8.66668C14.6555 8.44741 14.6666 8.22501 14.6666 8.00001C14.6666 7.77501 14.6555 7.55261 14.6337 7.33334H1.36623C1.34446 7.55261 1.33331 7.77501 1.33331 8.00001C1.33331 8.22501 1.34446 8.44741 1.36623 8.66668H14.6337Z"
        fill="#777E91"
      />
    </svg>
  );
}

export function LeftArrowIcon() {
  return (
    <svg
      width="1.4em"
      height="0.9em"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.90906 0.265207C4.50324 -0.109399 3.87058 -0.0840962 3.49597 0.321722L0.265201 3.82168C-0.0883963 4.20474 -0.0884 4.79518 0.265194 5.17824L3.49597 8.67828C3.87057 9.08411 4.50323 9.10941 4.90905 8.73481C5.31487 8.36021 5.34018 7.72755 4.96558 7.32173L3.28397 5.49997L13 5.49997C13.5523 5.49997 14 5.05225 14 4.49997C14 3.94768 13.5523 3.49997 13 3.49997L3.284 3.49997L4.96557 1.67829C5.34018 1.27247 5.31487 0.639813 4.90906 0.265207Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RightArrowIcon() {
  return (
    <svg
      width="1.4em"
      height="0.9em"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09094 0.265207C9.49676 -0.109399 10.1294 -0.0840962 10.504 0.321722L13.7348 3.82168C14.0884 4.20474 14.0884 4.79518 13.7348 5.17824L10.504 8.67828C10.1294 9.08411 9.49677 9.10941 9.09095 8.73481C8.68513 8.36021 8.65982 7.72755 9.03442 7.32173L10.716 5.49997L0.999999 5.49997C0.447714 5.49997 -7.64154e-07 5.05225 -7.86799e-07 4.49997C-8.09444e-07 3.94768 0.447714 3.49997 0.999999 3.49997L10.716 3.49997L9.03443 1.67829C8.65982 1.27247 8.68513 0.639813 9.09094 0.265207Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function InstagramIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00081 0.466797C6.68327 0.466797 6.39243 0.47693 5.48219 0.518353C4.57374 0.559953 3.95364 0.703777 3.41106 0.914802C2.84981 1.13276 2.37372 1.42432 1.8994 1.89881C1.42473 2.37313 1.13317 2.84922 0.914502 3.41029C0.702944 3.95305 0.558942 4.57333 0.518053 5.48143C0.477342 6.39166 0.466675 6.68268 0.466675 9.00022C0.466675 11.3178 0.476986 11.6077 0.518231 12.5179C0.560009 13.4264 0.703833 14.0465 0.914679 14.5891C1.13282 15.1503 1.42437 15.6264 1.89887 16.1007C2.37301 16.5754 2.8491 16.8677 3.40999 17.0856C3.95293 17.2967 4.57321 17.4405 5.48148 17.4821C6.39171 17.5235 6.68238 17.5336 8.99974 17.5336C11.3175 17.5336 11.6074 17.5235 12.5176 17.4821C13.4261 17.4405 14.0469 17.2967 14.5898 17.0856C15.1509 16.8677 15.6263 16.5754 16.1004 16.1007C16.5751 15.6264 16.8667 15.1503 17.0853 14.5893C17.2951 14.0465 17.4391 13.4262 17.4818 12.5181C17.5227 11.6079 17.5333 11.3178 17.5333 9.00022C17.5333 6.68268 17.5227 6.39184 17.4818 5.4816C17.4391 4.57315 17.2951 3.95306 17.0853 3.41047C16.8667 2.84922 16.5751 2.37313 16.1004 1.89881C15.6258 1.42414 15.1511 1.13258 14.5893 0.914802C14.0453 0.703777 13.4249 0.559953 12.5164 0.518353C11.6062 0.47693 11.3164 0.466797 8.99814 0.466797H9.00081ZM8.23525 2.00457C8.46245 2.00421 8.71597 2.00457 9.00077 2.00457C11.2792 2.00457 11.5492 2.01274 12.449 2.05363C13.281 2.09168 13.7326 2.2307 14.0334 2.3475C14.4316 2.50217 14.7155 2.68706 15.014 2.98573C15.3127 3.2844 15.4976 3.56885 15.6526 3.96708C15.7694 4.26752 15.9086 4.71908 15.9464 5.55109C15.9873 6.45066 15.9962 6.72088 15.9962 8.99824C15.9962 11.2756 15.9873 11.5458 15.9464 12.4454C15.9084 13.2774 15.7694 13.729 15.6526 14.0294C15.4979 14.4276 15.3127 14.7112 15.014 15.0097C14.7153 15.3084 14.4318 15.4932 14.0334 15.6479C13.7329 15.7652 13.281 15.9039 12.449 15.942C11.5494 15.9828 11.2792 15.9917 9.00077 15.9917C6.72217 15.9917 6.45212 15.9828 5.55256 15.942C4.72055 15.9036 4.26899 15.7645 3.96801 15.6477C3.56978 15.4931 3.28533 15.3082 2.98666 15.0095C2.68799 14.7108 2.5031 14.4271 2.34808 14.0287C2.23128 13.7282 2.09208 13.2767 2.05421 12.4447C2.01332 11.5451 2.00514 11.2749 2.00514 8.99611C2.00514 6.71733 2.01332 6.44852 2.05421 5.54896C2.09226 4.71695 2.23128 4.26539 2.34808 3.96459C2.50275 3.56636 2.68799 3.28191 2.98666 2.98324C3.28533 2.68457 3.56978 2.49968 3.96801 2.34466C4.26881 2.22732 4.72055 2.08866 5.55256 2.05043C6.33977 2.01488 6.64484 2.00421 8.23525 2.00243V2.00457ZM13.5558 3.42147C12.9905 3.42147 12.5318 3.87961 12.5318 4.44513C12.5318 5.01047 12.9905 5.46914 13.5558 5.46914C14.1212 5.46914 14.5799 5.01047 14.5799 4.44513C14.5799 3.87979 14.1212 3.42147 13.5558 3.42147ZM9.00082 4.61793C6.58071 4.61793 4.61855 6.58008 4.61855 9.0002C4.61855 11.4203 6.58071 13.3816 9.00082 13.3816C11.4209 13.3816 13.3824 11.4203 13.3824 9.0002C13.3824 6.58008 11.4209 4.61793 9.00082 4.61793ZM9.00079 6.15572C10.5717 6.15572 11.8453 7.42916 11.8453 9.0002C11.8453 10.5711 10.5717 11.8447 9.00079 11.8447C7.42975 11.8447 6.15632 10.5711 6.15632 9.0002C6.15632 7.42916 7.42975 6.15572 9.00079 6.15572Z"
        fill="#5B5B5B"
      />
    </svg>
  );
}

export function TwitterIcon() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5208 4.0051L7.55438 4.55873L6.99479 4.49094C4.95791 4.23107 3.17843 3.34977 1.66756 1.86964L0.928908 1.13523L0.73865 1.67757C0.33575 2.88653 0.593158 4.16328 1.43253 5.02198C1.8802 5.49653 1.77948 5.56432 1.00725 5.28185C0.73865 5.19146 0.503625 5.12367 0.481242 5.15757C0.4029 5.23666 0.6715 6.26484 0.884142 6.67159C1.17513 7.23653 1.76828 7.79016 2.4174 8.11782L2.96579 8.37769L2.31668 8.38899C1.68994 8.38899 1.66756 8.40029 1.73471 8.63756C1.95854 9.37198 2.84268 10.1516 3.82755 10.4906L4.52143 10.7278L3.91708 11.0894C3.02175 11.6091 1.96973 11.9029 0.917717 11.9255C0.414092 11.9368 0 11.982 0 12.0159C0 12.1289 1.36538 12.7616 2.15999 13.0102C4.54382 13.7446 7.37531 13.4282 9.50173 12.1741C11.0126 11.2815 12.5235 9.50756 13.2286 7.79016C13.6091 6.87497 13.9896 5.20276 13.9896 4.40055C13.9896 3.88081 14.0232 3.81302 14.6499 3.19159C15.0192 2.83003 15.3662 2.43458 15.4333 2.32159C15.5452 2.10692 15.534 2.10692 14.9633 2.299C14.012 2.63796 13.8777 2.59276 14.3477 2.08432C14.6947 1.72276 15.1088 1.06744 15.1088 0.875359C15.1088 0.841463 14.9409 0.897957 14.7506 0.999645C14.5492 1.11263 14.1015 1.28211 13.7658 1.3838L13.1614 1.57588L12.613 1.20302C12.3108 0.999645 11.8856 0.773671 11.6617 0.705879C11.0909 0.547697 10.218 0.570295 9.70318 0.751074C8.30422 1.25952 7.42008 2.57016 7.5208 4.0051Z"
        fill="#5B5B5B"
      />
    </svg>
  );
}
export function YouTubeIcon() {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6677 0.49952C16.4021 0.70103 16.9804 1.29478 17.1767 2.04878C17.5333 3.41533 17.5333 6.26663 17.5333 6.26663C17.5333 6.26663 17.5333 9.11784 17.1767 10.4845C16.9804 11.2385 16.4021 11.8322 15.6677 12.0338C14.3369 12.4 9.00001 12.4 9.00001 12.4C9.00001 12.4 3.66309 12.4 2.33218 12.0338C1.59783 11.8322 1.0195 11.2385 0.823232 10.4845C0.466675 9.11784 0.466675 6.26663 0.466675 6.26663C0.466675 6.26663 0.466675 3.41533 0.823232 2.04878C1.0195 1.29478 1.59783 0.70103 2.33218 0.49952C3.66309 0.133301 9.00001 0.133301 9.00001 0.133301C9.00001 0.133301 14.3369 0.133301 15.6677 0.49952ZM7.40002 3.86658V9.19991L11.6667 6.53335L7.40002 3.86658Z"
        fill="#5B5B5B"
      />
    </svg>
  );
}

export function BurgerIcon() {
  return (
    <svg
      width="22"
      height="12"
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66667 0.666504C0.930289 0.666504 0.333336 1.26346 0.333336 1.99984C0.333336 2.73622 0.930289 3.33317 1.66667 3.33317H20.3333C21.0697 3.33317 21.6667 2.73622 21.6667 1.99984C21.6667 1.26346 21.0697 0.666504 20.3333 0.666504H1.66667Z"
        fill="#777E91"
      />
      <path
        d="M1.66667 8.6665C0.930289 8.6665 0.333336 9.26346 0.333336 9.99984C0.333336 10.7362 0.930289 11.3332 1.66667 11.3332H20.3333C21.0697 11.3332 21.6667 10.7362 21.6667 9.99984C21.6667 9.26346 21.0697 8.6665 20.3333 8.6665H1.66667Z"
        fill="#777E91"
      />
    </svg>
  );
}

export function LineIcon() {
  return (
    <svg
      width="1"
      height="27"
      viewBox="0 0 1 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="27" stroke="#DBDBDB" />
    </svg>
  );
}

export function StarIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.26769 0.771504L8.34956 2.90038L10.7783 3.24313C11.9161 3.40365 12.4362 4.80771 11.5591 5.63743L9.81456 7.28626L10.2251 9.60958C10.4354 10.7998 9.17219 11.5991 8.17749 11.0923L5.99989 9.98149L3.82294 11.0919C2.82677 11.6004 1.56462 10.7984 1.77462 9.60963L2.18521 7.28626L0.440938 5.63766C-0.436791 4.80734 0.0851323 3.40358 1.22135 3.24315L3.6503 2.90036L4.73271 0.771504C5.25549 -0.257123 6.745 -0.257213 7.26769 0.771504Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronDownIcon() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20711 0.792893C8.81658 0.402369 8.18342 0.402369 7.79289 0.792893L5 3.58579L2.20711 0.792893C1.81658 0.402369 1.18342 0.402369 0.792894 0.792893C0.402369 1.18342 0.402369 1.81658 0.792894 2.20711L4.29289 5.70711C4.68342 6.09763 5.31658 6.09763 5.70711 5.70711L9.20711 2.20711C9.59763 1.81658 9.59763 1.18342 9.20711 0.792893Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronRightIcon() {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.792893 0.792893C0.402369 1.18342 0.402369 1.81658 0.792893 2.20711L3.58579 5L0.792893 7.79289C0.402369 8.18342 0.402369 8.81658 0.792893 9.20711C1.18342 9.59763 1.81658 9.59763 2.20711 9.20711L5.70711 5.70711C6.09763 5.31658 6.09763 4.68342 5.70711 4.29289L2.20711 0.792893C1.81658 0.402369 1.18342 0.402369 0.792893 0.792893Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function ChevronLeftIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4714 5.19526C9.73175 5.45561 9.73175 5.87772 9.4714 6.13807L7.60948 8L9.4714 9.86193C9.73175 10.1223 9.73175 10.5444 9.4714 10.8047C9.21106 11.0651 8.78895 11.0651 8.5286 10.8047L6.19526 8.4714C5.93491 8.21106 5.93491 7.78895 6.19526 7.5286L8.5286 5.19526C8.78895 4.93491 9.21106 4.93491 9.4714 5.19526Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CancelIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.366117 13.4476C-0.122039 13.9357 -0.122039 14.7272 0.366117 15.2154C0.854272 15.7035 1.64573 15.7035 2.13388 15.2154L7.7907 9.55854L13.4476 15.2155C13.9358 15.7036 14.7273 15.7036 15.2154 15.2155C15.7036 14.7273 15.7036 13.9359 15.2154 13.4477L9.55847 7.79077L15.2154 2.13388C15.7035 1.64573 15.7035 0.854272 15.2154 0.366116C14.7272 -0.122039 13.9357 -0.122039 13.4476 0.366117L7.7907 6.023L2.13394 0.366237C1.64578 -0.121918 0.854327 -0.121918 0.366172 0.366237C-0.121983 0.854393 -0.121983 1.64585 0.366172 2.134L6.02294 7.79077L0.366117 13.4476Z"
        fill="#777E90"
      />
    </svg>
  );
}

export function TruckIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.9585C0 3.78489 0.951395 2.8335 2.125 2.8335H7.79167C8.96527 2.8335 9.91667 3.78489 9.91667 4.9585V11.3335C9.91667 12.1159 9.2824 12.7502 8.5 12.7502H5.66667V11.3335H8.14583C8.34143 11.3335 8.5 11.1749 8.5 10.9793V4.9585C8.5 4.56729 8.18287 4.25016 7.79167 4.25016H2.125C1.7338 4.25016 1.41667 4.56729 1.41667 4.9585V10.6252C1.41667 11.0164 1.7338 11.3335 2.125 11.3335H2.83333V12.7502H2.125C0.951395 12.7502 0 11.7988 0 10.6252V4.9585Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 4.9585H12.9094C13.4391 4.9585 13.9498 5.15633 14.3412 5.51322L16.3067 7.30533C16.7483 7.70799 17 8.27799 17 8.87562V10.6252C17 11.7988 16.0486 12.7502 14.875 12.7502H14.1667V11.3335H14.875C15.2662 11.3335 15.5833 11.0164 15.5833 10.6252V8.87562C15.5833 8.67641 15.4994 8.48641 15.3522 8.35219L13.3867 6.56007C13.2562 6.44111 13.086 6.37516 12.9094 6.37516H10.625C10.2338 6.37516 9.91667 6.69229 9.91667 7.0835V10.9793C9.91667 11.1749 10.0752 11.3335 10.2708 11.3335H11.3333V12.7502H8.5V4.9585Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 12.7498C4.6412 12.7498 4.95833 12.4327 4.95833 12.0415C4.95833 11.6503 4.6412 11.3332 4.25 11.3332C3.8588 11.3332 3.54167 11.6503 3.54167 12.0415C3.54167 12.4327 3.8588 12.7498 4.25 12.7498ZM4.25 14.1665C5.4236 14.1665 6.375 13.2151 6.375 12.0415C6.375 10.8679 5.4236 9.9165 4.25 9.9165C3.07639 9.9165 2.125 10.8679 2.125 12.0415C2.125 13.2151 3.07639 14.1665 4.25 14.1665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 12.7498C13.1412 12.7498 13.4583 12.4327 13.4583 12.0415C13.4583 11.6503 13.1412 11.3332 12.75 11.3332C12.3588 11.3332 12.0417 11.6503 12.0417 12.0415C12.0417 12.4327 12.3588 12.7498 12.75 12.7498ZM12.75 14.1665C13.9236 14.1665 14.875 13.2151 14.875 12.0415C14.875 10.8679 13.9236 9.9165 12.75 9.9165C11.5764 9.9165 10.625 10.8679 10.625 12.0415C10.625 13.2151 11.5764 14.1665 12.75 14.1665Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41659 11.3335C1.02538 11.3335 0.708252 11.6506 0.708252 12.0418C0.708252 12.433 1.02538 12.7502 1.41659 12.7502H9.20825C9.59945 12.7502 9.91658 12.433 9.91658 12.0418C9.91658 11.6506 9.59945 11.3335 9.20825 11.3335H1.41659ZM13.4583 11.3335C13.067 11.3335 12.7499 11.6506 12.7499 12.0418C12.7499 12.433 13.067 12.7502 13.4583 12.7502H15.5833C15.9745 12.7502 16.2916 12.433 16.2916 12.0418C16.2916 11.6506 15.9745 11.3335 15.5833 11.3335H13.4583Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3333 13.4585C12.1157 13.4585 12.75 12.8242 12.75 12.0418C12.75 11.2594 12.1157 10.6252 11.3333 10.6252C10.5509 10.6252 9.91667 11.2594 9.91667 12.0418C9.91667 12.8242 10.5509 13.4585 11.3333 13.4585ZM11.3333 14.8752C12.8981 14.8752 14.1667 13.6066 14.1667 12.0418C14.1667 10.477 12.8981 9.2085 11.3333 9.2085C9.76853 9.2085 8.5 10.477 8.5 12.0418C8.5 13.6066 9.76853 14.8752 11.3333 14.8752Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.41659 4.25C1.02538 4.25 0.708252 4.56713 0.708252 4.95833C0.708252 5.34954 1.02538 5.66667 1.41659 5.66667H3.54159C3.93279 5.66667 4.24992 5.34954 4.24992 4.95833C4.24992 4.56713 3.93279 4.25 3.54159 4.25H1.41659ZM7.79158 4.25C7.40038 4.25 7.08325 4.56713 7.08325 4.95833C7.08325 5.34954 7.40038 5.66667 7.79158 5.66667H15.5833C15.9745 5.66667 16.2916 5.34954 16.2916 4.95833C16.2916 4.56713 15.9745 4.25 15.5833 4.25H7.79158Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66659 6.375C6.44899 6.375 7.08325 5.74074 7.08325 4.95833C7.08325 4.17593 6.44899 3.54167 5.66659 3.54167C4.88418 3.54167 4.24992 4.17593 4.24992 4.95833C4.24992 5.74074 4.88418 6.375 5.66659 6.375ZM5.66659 7.79167C7.23139 7.79167 8.49992 6.52314 8.49992 4.95833C8.49992 3.39353 7.23139 2.125 5.66659 2.125C4.10178 2.125 2.83325 3.39353 2.83325 4.95833C2.83325 6.52314 4.10178 7.79167 5.66659 7.79167Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SettingsIcon2() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71981 13H5.28111C4.9663 13 4.69391 12.7874 4.62654 12.4891L4.35386 11.2645C3.9901 11.1099 3.64518 10.9165 3.32545 10.688L2.09471 11.0682C1.79456 11.1611 1.46828 11.0385 1.31084 10.7738L0.0888085 8.7256C-0.0669016 8.46073 -0.0132563 8.12662 0.218114 7.92025L1.17283 7.07525C1.12941 6.69247 1.12941 6.30623 1.17283 5.92345L0.218114 5.0804C-0.0135971 4.87394 -0.0672637 4.53942 0.0888085 4.2744L1.30816 2.22495C1.4656 1.9602 1.79188 1.83764 2.09203 1.9305L3.32277 2.31075C3.48629 2.1932 3.65651 2.0847 3.83262 1.98575C4.00168 1.89325 4.17567 1.8095 4.35386 1.73485L4.62721 0.51155C4.69426 0.21318 4.96635 0.000321355 5.28111 0H7.71981C8.03457 0.000321355 8.30666 0.21318 8.37371 0.51155L8.64974 1.7355C8.83786 1.81579 9.02106 1.9065 9.19845 2.0072C9.36388 2.10003 9.52381 2.20181 9.67748 2.31205L10.9089 1.9318C11.2088 1.83929 11.5347 1.9618 11.6921 2.22625L12.9114 4.2757C13.0672 4.54056 13.0135 4.87468 12.7821 5.08105L11.8274 5.92605C11.8708 6.30883 11.8708 6.69507 11.8274 7.07785L12.7821 7.92285C13.0135 8.12922 13.0672 8.46334 12.9114 8.7282L11.6921 10.7776C11.5347 11.0421 11.2088 11.1646 10.9089 11.0721L9.67748 10.6918C9.52166 10.8032 9.35973 10.9063 9.19242 11.0006C9.01677 11.0993 8.83559 11.1885 8.64974 11.2677L8.37371 12.4891C8.30639 12.7872 8.03437 12.9997 7.71981 13ZM3.56597 9.24885L4.11535 9.63885C4.2392 9.72735 4.36828 9.80874 4.50193 9.8826C4.62768 9.95326 4.75717 10.0175 4.88984 10.075L5.51493 10.3408L5.82111 11.7H7.18115L7.48733 10.3402L8.11242 10.0744C8.3853 9.9576 8.64431 9.81245 8.8849 9.64145L9.43495 9.25145L10.8024 9.67395L11.4824 8.53125L10.4218 7.5933L10.4969 6.9355C10.5298 6.64779 10.5298 6.35741 10.4969 6.0697L10.4218 5.4119L11.4831 4.472L10.8024 3.32865L9.43495 3.75115L8.8849 3.36115C8.64424 3.18936 8.38526 3.04314 8.11242 2.925L7.48733 2.65915L7.18115 1.3H5.82111L5.51359 2.6598L4.88984 2.925C4.75706 2.98158 4.62756 3.04516 4.50193 3.11545C4.3691 3.18911 4.2407 3.27006 4.11736 3.3579L3.56731 3.7479L2.20057 3.3254L1.5192 4.472L2.57977 5.40865L2.50474 6.0671C2.47177 6.35481 2.47177 6.64519 2.50474 6.9329L2.57977 7.5907L1.5192 8.52865L2.19923 9.67135L3.56597 9.24885ZM6.49778 9.1C5.01771 9.1 3.81788 7.93594 3.81788 6.5C3.81788 5.06406 5.01771 3.9 6.49778 3.9C7.97785 3.9 9.17768 5.06406 9.17768 6.5C9.17583 7.9352 7.97708 9.09821 6.49778 9.1ZM6.49778 5.2C5.76576 5.20072 5.16982 5.77125 5.15933 6.48137C5.14884 7.19149 5.72769 7.77836 6.45938 7.79943C7.19108 7.8205 7.80479 7.26797 7.83773 6.5585V6.8185V6.5C7.83773 5.78203 7.23781 5.2 6.49778 5.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BoxesIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6667 10.8333H11.2501C11.02 10.8333 10.8334 11.0199 10.8334 11.25V17.0833C10.8334 17.3134 11.02 17.5 11.2501 17.5H16.6667C17.127 17.5 17.5001 17.1269 17.5001 16.6667V11.6667C17.5001 11.2064 17.127 10.8333 16.6667 10.8333ZM9.16675 9.16666V19.1667H16.6667C18.0475 19.1667 19.1667 18.0474 19.1667 16.6667V11.6667C19.1667 10.2859 18.0475 9.16666 16.6667 9.16666H9.16675Z"
        fill="currentColor"
      />
      <path
        d="M13.3333 9.16666H14.9999V11.6667C14.9999 12.1269 14.6268 12.5 14.1666 12.5C13.7063 12.5 13.3333 12.1269 13.3333 11.6667V9.16666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16659 11.25C9.16659 11.0199 8.98004 10.8333 8.74992 10.8333H3.33325C2.87302 10.8333 2.49992 11.2064 2.49992 11.6667V16.6667C2.49992 17.1269 2.87302 17.5 3.33325 17.5H8.74992C8.98004 17.5 9.16659 17.3134 9.16659 17.0833V11.25ZM3.33325 9.16666C1.95254 9.16666 0.833252 10.2859 0.833252 11.6667V16.6667C0.833252 18.0474 1.95254 19.1667 3.33325 19.1667H10.8333V9.16666H3.33325Z"
        fill="currentColor"
      />
      <path
        d="M5 9.16666H6.66667V11.6667C6.66667 12.1269 6.29357 12.5 5.83333 12.5C5.3731 12.5 5 12.1269 5 11.6667V9.16666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2.50001H7.5C7.03976 2.50001 6.66667 2.87311 6.66667 3.33334V9.16668H13.3333V3.33334C13.3333 2.87311 12.9602 2.50001 12.5 2.50001ZM7.5 0.833344C6.11929 0.833344 5 1.95263 5 3.33334V10.8333H15V3.33334C15 1.95263 13.8807 0.833344 12.5 0.833344H7.5Z"
        fill="currentColor"
      />
      <path
        d="M9.16675 0.833344H10.8334V3.33334C10.8334 3.79358 10.4603 4.16668 10.0001 4.16668C9.53984 4.16668 9.16675 3.79358 9.16675 3.33334V0.833344Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HomeIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99305 3.476L10 3.47238L10.0073 3.47615L13.7185 5.70287L15 6.47498V15.6667C15 16.1609 14.9987 16.4313 14.9828 16.6256L14.9809 16.6476L14.959 16.6495C14.7647 16.6654 14.4942 16.6667 14 16.6667H6.00002C5.50581 16.6667 5.23539 16.6654 5.04108 16.6495L5.0191 16.6476L5.01719 16.6256C5.00132 16.4313 5.00002 16.1609 5.00002 15.6667V6.475L6.27683 5.70573L9.99305 3.476ZM5.4181 4.27731L1.23796 6.78539C0.843315 7.02218 0.715344 7.53407 0.952134 7.92872C1.18892 8.32337 1.70081 8.45134 2.09546 8.21455L3.33335 7.47181V15.6667C3.33335 16.6001 3.33335 17.0668 3.51501 17.4234C3.6748 17.737 3.92977 17.9919 4.24337 18.1517C4.59989 18.3334 5.0666 18.3334 6.00002 18.3334H14C14.9334 18.3334 15.4002 18.3334 15.7567 18.1517C16.0703 17.9919 16.3252 17.737 16.485 17.4234C16.6667 17.0668 16.6667 16.6001 16.6667 15.6667V7.47178L17.9046 8.21455C18.2993 8.45134 18.8112 8.32337 19.048 7.92872C19.2847 7.53407 19.1568 7.02218 18.7621 6.78539L14.5772 4.27443L11.3762 2.34586C11.1435 2.20565 10.9649 2.09805 10.8135 2.01713C10.7782 1.99738 10.7423 1.979 10.706 1.962C10.58 1.90054 10.4709 1.85962 10.3587 1.8349C10.1224 1.78284 9.87763 1.78284 9.64135 1.8349C9.52888 1.85969 9.41943 1.90075 9.29305 1.96248C9.25738 1.9792 9.22216 1.99725 9.18747 2.01663C9.03591 2.0976 8.85706 2.20535 8.62386 2.34586L5.4181 4.27731Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8333 16.6667V13.3333C10.8333 12.8731 10.4602 12.5 10 12.5C9.53976 12.5 9.16667 12.8731 9.16667 13.3333V16.6667H10.8333ZM10 10.8333C8.61929 10.8333 7.5 11.9526 7.5 13.3333V18.3333H12.5V13.3333C12.5 11.9526 11.3807 10.8333 10 10.8333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StarIconStroked() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.93538 7.4447C7.85119 7.64635 7.66135 7.78403 7.44352 7.80142L3.4858 8.11748C2.96795 8.15884 2.75841 8.8055 3.1536 9.14271L6.16562 11.7128C6.33247 11.8552 6.40535 12.0791 6.35428 12.2924L5.43347 16.1377C5.31269 16.6421 5.8609 17.0414 6.30397 16.7719L9.69681 14.7076C9.88306 14.5942 10.117 14.5942 10.3032 14.7076L13.6961 16.7719C14.1391 17.0414 14.6873 16.6421 14.5666 16.1377L13.6457 12.2924C13.5947 12.0791 13.6676 11.8552 13.8344 11.7128L16.8464 9.14271C17.2416 8.8055 17.0321 8.15884 16.5142 8.11748L12.5565 7.80142C12.3387 7.78403 12.1488 7.64635 12.0646 7.4447L10.5383 3.78919C10.3387 3.31109 9.66134 3.31109 9.46172 3.78919L7.93538 7.4447ZM13.348 6.19266L12.0763 3.14701C11.3063 1.30292 8.69372 1.30293 7.92373 3.14701L6.65205 6.19266L3.35312 6.4561C1.35569 6.61562 0.547481 9.1099 2.07177 10.4106L4.57885 12.5498L3.81263 15.7495C3.34676 17.695 5.46128 19.2355 7.17027 18.1957L10 16.474L12.8298 18.1957C14.5387 19.2355 16.6533 17.695 16.1874 15.7495L15.4212 12.5498L17.9283 10.4105C19.4526 9.10989 18.6443 6.61562 16.6469 6.4561L13.348 6.19266Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ShareIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49882 8.36657C7.52332 8.82615 7.17061 9.21858 6.71103 9.24308C6.08379 9.27652 5.587 9.31742 5.19878 9.35836C4.67743 9.41335 4.36065 9.73359 4.30799 10.1942C4.23238 10.8556 4.16667 11.8565 4.16667 13.3334C4.16667 14.8102 4.23238 15.8111 4.30799 16.4725C4.36074 16.9339 4.67672 17.2532 5.19729 17.3082C6.10898 17.4044 7.61604 17.5 10 17.5C12.384 17.5 13.891 17.4044 14.8027 17.3082C15.3233 17.2532 15.6393 16.9339 15.692 16.4725C15.7676 15.8111 15.8333 14.8102 15.8333 13.3334C15.8333 11.8565 15.7676 10.8556 15.692 10.1942C15.6394 9.73359 15.3226 9.41335 14.8012 9.35836C14.413 9.31742 13.9162 9.27652 13.289 9.24308C12.8294 9.21858 12.4767 8.82615 12.5012 8.36657C12.5257 7.90698 12.9181 7.55428 13.3777 7.57878C14.0301 7.61356 14.5558 7.65657 14.976 7.70089C16.213 7.83135 17.1997 8.70893 17.3479 10.0049C17.4323 10.7436 17.5 11.8096 17.5 13.3334C17.5 14.8571 17.4323 15.9231 17.3479 16.6618C17.1998 17.957 16.2154 18.835 14.9776 18.9656C13.9933 19.0695 12.4257 19.1667 10 19.1667C7.57435 19.1667 6.00672 19.0695 5.02236 18.9656C3.78459 18.835 2.80017 17.957 2.65211 16.6618C2.56767 15.9231 2.5 14.8571 2.5 13.3334C2.5 11.8096 2.56767 10.7436 2.65211 10.0049C2.80026 8.70893 3.78697 7.83135 5.02397 7.70089C5.44422 7.65657 5.96994 7.61356 6.6223 7.57878C7.08189 7.55428 7.47432 7.90698 7.49882 8.36657Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67259 5.1726C7.34715 5.49804 6.81951 5.49804 6.49408 5.1726C6.16864 4.84716 6.16864 4.31952 6.49408 3.99409L9.41074 1.07742C9.73618 0.751984 10.2638 0.751984 10.5893 1.07742L13.5059 3.99409C13.8314 4.31952 13.8314 4.84716 13.5059 5.1726C13.1805 5.49804 12.6528 5.49804 12.3274 5.1726L10.8333 3.67852V11.6667C10.8333 12.1269 10.4602 12.5 10 12.5C9.53976 12.5 9.16667 12.1269 9.16667 11.6667V3.67852L7.67259 5.1726Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FlagIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.5L9.58504 2.65079C10.141 2.00212 9.68013 1 8.82578 1L2 1L2 8L8.82578 8C9.68013 8 10.141 6.99788 9.58504 6.34921L8 4.5ZM3 7L8.82578 7L6.68292 4.5L8.82578 2L3 2L3 7Z"
          fill="currentColor"
        />
        <path
          d="M2 0.5C2 0.223858 2.22386 0 2.5 0C2.77614 0 3 0.223858 3 0.5L3 11.5C3 11.7761 2.77614 12 2.5 12C2.22386 12 2 11.7761 2 11.5L2 0.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="1em" height="1em" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CalculatorIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1667 2.49967H5.83333C4.91286 2.49967 4.16667 3.24587 4.16667 4.16634V15.833C4.16667 16.7535 4.91286 17.4997 5.83333 17.4997H14.1667C15.0871 17.4997 15.8333 16.7535 15.8333 15.833V4.16634C15.8333 3.24587 15.0871 2.49967 14.1667 2.49967ZM5.83333 0.833008C3.99238 0.833008 2.5 2.32539 2.5 4.16634V15.833C2.5 17.674 3.99238 19.1663 5.83333 19.1663H14.1667C16.0076 19.1663 17.5 17.674 17.5 15.833V4.16634C17.5 2.32539 16.0076 0.833008 14.1667 0.833008H5.83333Z"
        fill="currentColor"
      />
      <path
        d="M6.66668 4.16699C6.20644 4.16699 5.83334 4.54009 5.83334 5.00033C5.83334 5.46056 6.20644 5.83366 6.66668 5.83366H13.3333C13.7936 5.83366 14.1667 5.46056 14.1667 5.00033C14.1667 4.54009 13.7936 4.16699 13.3333 4.16699H6.66668Z"
        fill="currentColor"
      />
      <path
        d="M6.66668 9.16699C7.12691 9.16699 7.50001 8.7939 7.50001 8.33366C7.50001 7.87342 7.12691 7.50033 6.66668 7.50033C6.20644 7.50033 5.83334 7.87342 5.83334 8.33366C5.83334 8.7939 6.20644 9.16699 6.66668 9.16699Z"
        fill="currentColor"
      />
      <path
        d="M10 9.16699C10.4602 9.16699 10.8333 8.7939 10.8333 8.33366C10.8333 7.87342 10.4602 7.50033 10 7.50033C9.53977 7.50033 9.16668 7.87342 9.16668 8.33366C9.16668 8.7939 9.53977 9.16699 10 9.16699Z"
        fill="currentColor"
      />
      <path
        d="M14.1667 8.33366C14.1667 8.7939 13.7936 9.16699 13.3333 9.16699C12.8731 9.16699 12.5 8.7939 12.5 8.33366C12.5 7.87342 12.8731 7.50033 13.3333 7.50033C13.7936 7.50033 14.1667 7.87342 14.1667 8.33366Z"
        fill="currentColor"
      />
      <path
        d="M6.66668 12.5003C7.12691 12.5003 7.50001 12.1272 7.50001 11.667C7.50001 11.2068 7.12691 10.8337 6.66668 10.8337C6.20644 10.8337 5.83334 11.2068 5.83334 11.667C5.83334 12.1272 6.20644 12.5003 6.66668 12.5003Z"
        fill="currentColor"
      />
      <path
        d="M10.8333 11.667C10.8333 12.1272 10.4602 12.5003 10 12.5003C9.53977 12.5003 9.16668 12.1272 9.16668 11.667C9.16668 11.2068 9.53977 10.8337 10 10.8337C10.4602 10.8337 10.8333 11.2068 10.8333 11.667Z"
        fill="currentColor"
      />
      <path
        d="M13.3333 12.5003C13.7936 12.5003 14.1667 12.1272 14.1667 11.667C14.1667 11.2068 13.7936 10.8337 13.3333 10.8337C12.8731 10.8337 12.5 11.2068 12.5 11.667C12.5 12.1272 12.8731 12.5003 13.3333 12.5003Z"
        fill="currentColor"
      />
      <path
        d="M7.50001 15.0003C7.50001 15.4606 7.12691 15.8337 6.66668 15.8337C6.20644 15.8337 5.83334 15.4606 5.83334 15.0003C5.83334 14.5401 6.20644 14.167 6.66668 14.167C7.12691 14.167 7.50001 14.5401 7.50001 15.0003Z"
        fill="currentColor"
      />
      <path
        d="M10 15.8337C10.4602 15.8337 10.8333 15.4606 10.8333 15.0003C10.8333 14.5401 10.4602 14.167 10 14.167C9.53977 14.167 9.16668 14.5401 9.16668 15.0003C9.16668 15.4606 9.53977 15.8337 10 15.8337Z"
        fill="currentColor"
      />
      <path
        d="M14.1667 15.0003C14.1667 15.4606 13.7936 15.8337 13.3333 15.8337C12.8731 15.8337 12.5 15.4606 12.5 15.0003C12.5 14.5401 12.8731 14.167 13.3333 14.167C13.7936 14.167 14.1667 14.5401 14.1667 15.0003Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StarIcon2() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38796 2.08514C7.61956 1.54844 8.38057 1.54844 8.61218 2.08514L10.0655 5.45307C10.1636 5.68032 10.3795 5.83454 10.6263 5.85361L14.3534 6.14161C14.9514 6.18781 15.189 6.93852 14.7265 7.32038L11.9235 9.63456C11.7258 9.79779 11.6392 10.0599 11.7008 10.3088L12.5635 13.7944C12.7053 14.3676 12.087 14.8286 11.5781 14.529L8.33828 12.6217C8.12955 12.4988 7.87059 12.4988 7.66185 12.6217L4.42203 14.529C3.91316 14.8286 3.29481 14.3676 3.43667 13.7944L4.2993 10.3088C4.36089 10.0599 4.27431 9.79779 4.0766 9.63456L1.27368 7.32038C0.811174 6.93852 1.04878 6.18781 1.64677 6.14161L5.37387 5.85361C5.62065 5.83454 5.83655 5.68032 5.93461 5.45307L7.38796 2.08514Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AttachIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5564 12.6066L11.546 18.617C9.78863 20.3744 6.93939 20.3744 5.18203 18.617C3.42467 16.8597 3.42467 14.0104 5.18203 12.2531L13.3138 4.12136C14.4853 2.94978 16.3848 2.94978 17.5564 4.12136C18.728 5.29293 18.728 7.19242 17.5564 8.364L9.42467 16.4957C8.83889 17.0815 7.88914 17.0815 7.30335 16.4957C6.71757 15.9099 6.71757 14.9602 7.30335 14.3744L13.3138 8.364"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmileyIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM6.97195 11.7648C6.84206 11.228 6.30161 10.8982 5.76481 11.028C5.22802 11.1579 4.89816 11.6984 5.02805 12.2352C5.29096 13.3217 5.9358 14.2791 6.84106 14.958C7.74527 15.6362 8.85924 16 10 16C11.1408 16 12.2547 15.6362 13.1589 14.958C14.0642 14.2791 14.709 13.3217 14.972 12.2352C15.1018 11.6984 14.772 11.1579 14.2352 11.028C13.6984 10.8982 13.1579 11.228 13.028 11.7648C12.8786 12.3824 12.5072 12.9468 11.9589 13.358C11.4096 13.77 10.719 14 10 14C9.281 14 8.59039 13.77 8.04106 13.358C7.49278 12.9468 7.12138 12.3824 6.97195 11.7648ZM8.17856 8.98393C7.63515 9.08255 7.11469 8.72197 7.01607 8.17856C7.01169 8.1544 7.00616 8.1326 7 8.11308C6.99384 8.1326 6.98831 8.1544 6.98393 8.17856C6.88531 8.72197 6.36485 9.08255 5.82144 8.98393C5.27803 8.88531 4.91745 8.36485 5.01607 7.82144C5.09929 7.36286 5.31014 6.91656 5.65316 6.57354C6.00072 6.22598 6.47316 6 7 6C7.52683 6 7.99928 6.22598 8.34684 6.57354C8.68985 6.91656 8.90071 7.36286 8.98393 7.82144C9.08255 8.36485 8.72197 8.88531 8.17856 8.98393ZM13.0161 8.17856C13.1147 8.72197 13.6352 9.08255 14.1786 8.98393C14.722 8.88531 15.0825 8.36485 14.9839 7.82144C14.9007 7.36286 14.6899 6.91656 14.3468 6.57354C13.9993 6.22598 13.5268 6 13 6C12.4732 6 12.0007 6.22598 11.6532 6.57354C11.3101 6.91656 11.0993 7.36286 11.0161 7.82144C10.9175 8.36485 11.278 8.88531 11.8214 8.98393C12.3648 9.08255 12.8853 8.72197 12.9839 8.17856C12.9883 8.1544 12.9938 8.1326 13 8.11308C13.0062 8.1326 13.0117 8.1544 13.0161 8.17856Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TickIcon() {
  return (
    <svg
      width="1.4em"
      height="1em"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5L5 9L13 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 0.292893C0.683417 -0.0976309 1.31658 -0.0976309 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683418 14.0976 0.292893 13.7071C-0.0976309 13.3166 -0.0976309 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CircledCheck() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.5 123C95.4655 123 123 95.4655 123 61.5C123 27.5345 95.4655 0 61.5 0C27.5345 0 0 27.5345 0 61.5C0 95.4655 27.5345 123 61.5 123Z"
        fill="transparent"
      />
      <path
        d="M61.5 120.5C94.0848 120.5 120.5 94.0848 120.5 61.5C120.5 28.9152 94.0848 2.5 61.5 2.5C28.9152 2.5 2.5 28.9152 2.5 61.5C2.5 94.0848 28.9152 120.5 61.5 120.5Z"
        stroke="currentColor"
        strokeWidth="5"
      />
      <path
        d="M33.0005 63.542C33.1635 63.684 56.9858 86.3486 56.9858 86.3486L90.8228 50.3486L94.9146 45.9961"
        stroke="currentColor"
        strokeWidth="5"
      />
    </svg>
  );
}

export function CopyIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1855 25H5.85938C3.70541 25 1.95312 23.2477 1.95312 21.0938V7.86133C1.95312 5.70736 3.70541 3.95508 5.85938 3.95508H15.1855C17.3395 3.95508 19.0918 5.70736 19.0918 7.86133V21.0938C19.0918 23.2477 17.3395 25 15.1855 25ZM5.85938 5.9082C4.78249 5.9082 3.90625 6.78444 3.90625 7.86133V21.0938C3.90625 22.1706 4.78249 23.0469 5.85938 23.0469H15.1855C16.2624 23.0469 17.1387 22.1706 17.1387 21.0938V7.86133C17.1387 6.78444 16.2624 5.9082 15.1855 5.9082H5.85938ZM22.998 18.6523V3.90625C22.998 1.75228 21.2458 0 19.0918 0H8.25195C7.71255 0 7.27539 0.437164 7.27539 0.976562C7.27539 1.51596 7.71255 1.95312 8.25195 1.95312H19.0918C20.1687 1.95312 21.0449 2.82936 21.0449 3.90625V18.6523C21.0449 19.1917 21.4821 19.6289 22.0215 19.6289C22.5609 19.6289 22.998 19.1917 22.998 18.6523Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GoogleIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7001 9.19996C17.7001 8.45997 17.6408 7.91998 17.5127 7.35999H9.17761V10.6999H14.0701C13.9715 11.53 13.4388 12.78 12.2551 13.6199L12.2386 13.7317L14.8739 15.8015L15.0565 15.82C16.7334 14.2499 17.7001 11.9399 17.7001 9.19996Z"
        fill="#4285F4"
      />
      <path
        d="M9.1771 18C11.574 18 13.5862 17.2 15.056 15.82L12.2546 13.62C11.505 14.15 10.4988 14.52 9.1771 14.52C6.8295 14.52 4.83699 12.95 4.12672 10.78L4.02261 10.789L1.2823 12.939L1.24646 13.04C2.70631 15.98 5.70496 18 9.1771 18Z"
        fill="#34A853"
      />
      <path
        d="M4.12723 10.78C3.93982 10.22 3.83136 9.61992 3.83136 8.99995C3.83136 8.37991 3.93982 7.77993 4.11737 7.21994L4.1124 7.10068L1.33775 4.91614L1.24697 4.95991C0.645291 6.17993 0.300049 7.54995 0.300049 8.99995C0.300049 10.4499 0.645291 11.8199 1.24697 13.0399L4.12723 10.78Z"
        fill="#FBBC05"
      />
      <path
        d="M9.17711 3.47997C10.8441 3.47997 11.9686 4.20997 12.6098 4.82001L15.1152 2.34C13.5765 0.890003 11.574 0 9.17711 0C5.70497 0 2.70631 2.01998 1.24646 4.95995L4.11686 7.21998C4.837 5.04999 6.82951 3.47997 9.17711 3.47997Z"
        fill="#EB4335"
      />
    </svg>
  );
}

export function EyeIcon() {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9235 7.6C17.9035 2.91 14.1035 0 10.0035 0C5.90348 0 2.10348 2.91 0.0834848 7.6C0.0284215 7.72617 0 7.86234 0 8C0 8.13766 0.0284215 8.27383 0.0834848 8.4C2.10348 13.09 5.90348 16 10.0035 16C14.1035 16 17.9035 13.09 19.9235 8.4C19.9785 8.27383 20.007 8.13766 20.007 8C20.007 7.86234 19.9785 7.72617 19.9235 7.6ZM10.0035 14C6.82348 14 3.83348 11.71 2.10348 8C3.83348 4.29 6.82348 2 10.0035 2C13.1835 2 16.1735 4.29 17.9035 8C16.1735 11.71 13.1835 14 10.0035 14ZM10.0035 4C9.21236 4 8.439 4.2346 7.7812 4.67412C7.12341 5.11365 6.61072 5.73836 6.30797 6.46927C6.00522 7.20017 5.926 8.00444 6.08034 8.78036C6.23468 9.55628 6.61565 10.269 7.17506 10.8284C7.73447 11.3878 8.4472 11.7688 9.22312 11.9231C9.99905 12.0775 10.8033 11.9983 11.5342 11.6955C12.2651 11.3928 12.8898 10.8801 13.3294 10.2223C13.7689 9.56448 14.0035 8.79113 14.0035 8C14.0035 6.93913 13.5821 5.92172 12.8319 5.17157C12.0818 4.42143 11.0644 4 10.0035 4ZM10.0035 10C9.60792 10 9.22124 9.8827 8.89234 9.66294C8.56345 9.44318 8.3071 9.13082 8.15573 8.76537C8.00435 8.39991 7.96474 7.99778 8.04191 7.60982C8.11908 7.22186 8.30957 6.86549 8.58927 6.58579C8.86898 6.30608 9.22534 6.1156 9.6133 6.03843C10.0013 5.96126 10.4034 6.00087 10.7689 6.15224C11.1343 6.30362 11.4467 6.55996 11.6664 6.88886C11.8862 7.21776 12.0035 7.60444 12.0035 8C12.0035 8.53043 11.7928 9.03914 11.4177 9.41421C11.0426 9.78929 10.5339 10 10.0035 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EyeCrossIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.94018 5.08019C10.2909 5.02642 10.6453 4.99967 11.0002 5.00019C14.1802 5.00019 17.1702 7.29018 18.9102 11.0002C18.6441 11.5648 18.3435 12.1125 18.0102 12.6402C17.9044 12.804 17.8487 12.9952 17.8502 13.1902C17.8524 13.4084 17.926 13.6199 18.0596 13.7925C18.1933 13.965 18.3798 14.089 18.5905 14.1457C18.8013 14.2024 19.0248 14.1885 19.227 14.1063C19.4291 14.024 19.5988 13.8779 19.7102 13.6902C20.1761 12.9581 20.5808 12.1888 20.9202 11.3902C20.9738 11.2654 21.0015 11.131 21.0015 10.9952C21.0015 10.8594 20.9738 10.725 20.9202 10.6002C18.9002 5.91019 15.1002 3.00019 11.0002 3.00019C10.5309 2.99782 10.0623 3.03798 9.60019 3.12019C9.46886 3.14251 9.34322 3.19048 9.23044 3.26136C9.11766 3.33224 9.01994 3.42464 8.94287 3.53329C8.8658 3.64193 8.81088 3.76469 8.78125 3.89456C8.75162 4.02443 8.74786 4.15886 8.77018 4.29019C8.79251 4.42151 8.84048 4.54715 8.91136 4.65993C8.98224 4.77271 9.07464 4.87043 9.18329 4.9475C9.29193 5.02457 9.41469 5.07949 9.54456 5.10912C9.67443 5.13875 9.80886 5.14251 9.94018 5.12019V5.08019ZM2.71019 1.29019C2.61695 1.19695 2.50626 1.12299 2.38443 1.07253C2.26261 1.02207 2.13204 0.996094 2.00019 0.996094C1.86833 0.996094 1.73776 1.02207 1.61594 1.07253C1.49411 1.12299 1.38342 1.19695 1.29019 1.29019C1.10188 1.47849 0.996094 1.73388 0.996094 2.00019C0.996094 2.26649 1.10188 2.52188 1.29019 2.71019L4.39019 5.80019C2.97576 7.16171 1.85004 8.79417 1.08019 10.6002C1.02512 10.7264 0.996701 10.8625 0.996701 11.0002C0.996701 11.1378 1.02512 11.274 1.08019 11.4002C3.10019 16.0902 6.90019 19.0002 11.0002 19.0002C12.7973 18.9878 14.552 18.4527 16.0502 17.4602L19.2902 20.7102C19.3831 20.8039 19.4937 20.8783 19.6156 20.9291C19.7375 20.9798 19.8682 21.006 20.0002 21.006C20.1322 21.006 20.2629 20.9798 20.3848 20.9291C20.5066 20.8783 20.6172 20.8039 20.7102 20.7102C20.8039 20.6172 20.8783 20.5066 20.9291 20.3848C20.9798 20.2629 21.006 20.1322 21.006 20.0002C21.006 19.8682 20.9798 19.7375 20.9291 19.6156C20.8783 19.4937 20.8039 19.3831 20.7102 19.2902L2.71019 1.29019ZM9.07018 10.4802L11.5202 12.9302C11.3512 12.9787 11.176 13.0022 11.0002 13.0002C10.4698 13.0002 9.96104 12.7895 9.58597 12.4144C9.2109 12.0393 9.00019 11.5306 9.00019 11.0002C8.99814 10.8244 9.02172 10.6492 9.07018 10.4802ZM11.0002 17.0002C7.82018 17.0002 4.83019 14.7102 3.10019 11.0002C3.74627 9.57393 4.66326 8.28676 5.80019 7.21019L7.57019 9.00019C7.15443 9.75898 6.99592 10.6321 7.11844 11.4886C7.24096 12.3452 7.6379 13.1388 8.24971 13.7507C8.86152 14.3625 9.65522 14.7594 10.5117 14.8819C11.3682 15.0044 12.2414 14.8459 13.0002 14.4302L14.5902 16.0002C13.5013 16.6411 12.2636 16.9858 11.0002 17.0002Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BellIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 12.0155C14 12.3409 13.7362 12.6047 13.4109 12.6047H2.58915C2.26377 12.6047 2 12.3409 2 12.0155C2 11.6901 2.26377 11.4264 2.58915 11.4264H2.6V7.32059C2.6 4.38192 5.018 2 8 2C10.982 2 13.4 4.38192 13.4 7.32059V11.4264H13.4109C13.7362 11.4264 14 11.6901 14 12.0155ZM3.8 11.4264H12.2V7.32059C12.2 5.03293 10.3196 3.17829 8 3.17829C5.6804 3.17829 3.8 5.03293 3.8 7.32059V11.4264ZM6.83101 14.1167C6.48109 13.6894 6.94772 13.1938 7.5 13.1938H8.5C9.05229 13.1938 9.51891 13.6894 9.16899 14.1167C9.13524 14.1579 9.0991 14.1975 9.06066 14.2353C8.77936 14.5115 8.39782 14.6667 8 14.6667C7.60218 14.6667 7.22064 14.5115 6.93934 14.2353C6.9009 14.1975 6.86476 14.1579 6.83101 14.1167Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ExclamationIcon() {
  return (
    <svg
      width="4"
      height="11"
      viewBox="0 0 4 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.76855 6.94434H1.12793L0.895508 0.046875H3.00098L2.76855 6.94434ZM1.94824 8.02441C2.28092 8.02441 2.54753 8.1224 2.74805 8.31836C2.95312 8.51432 3.05566 8.76497 3.05566 9.07031C3.05566 9.37109 2.95312 9.61947 2.74805 9.81543C2.54753 10.0114 2.28092 10.1094 1.94824 10.1094C1.62012 10.1094 1.35352 10.0114 1.14844 9.81543C0.947917 9.61947 0.847656 9.37109 0.847656 9.07031C0.847656 8.76953 0.947917 8.52116 1.14844 8.3252C1.35352 8.12467 1.62012 8.02441 1.94824 8.02441Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CrossIcon2() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.52876 3.52864C3.78911 3.26829 4.21122 3.26829 4.47157 3.52864L8.00016 7.05723L11.5288 3.52864C11.7891 3.26829 12.2112 3.26829 12.4716 3.52864C12.7319 3.78899 12.7319 4.2111 12.4716 4.47145L8.94297 8.00004L12.4716 11.5286C12.7319 11.789 12.7319 12.2111 12.4716 12.4714C12.2112 12.7318 11.7891 12.7318 11.5288 12.4714L8.00016 8.94285L4.47157 12.4714C4.21122 12.7318 3.78911 12.7318 3.52876 12.4714C3.26841 12.2111 3.26841 11.789 3.52876 11.5286L7.05735 8.00004L3.52876 4.47145C3.26841 4.2111 3.26841 3.78899 3.52876 3.52864Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LeftArrowThin() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 7.27441L16.25 7.27441"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2998 13.299L1.2498 7.275L7.2998 1.25"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RouteIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6665 13.3334C13.0347 13.3334 13.3332 13.0349 13.3332 12.6667C13.3332 12.2986 13.0347 12.0001 12.6665 12.0001C12.2983 12.0001 11.9998 12.2986 11.9998 12.6667C11.9998 13.0349 12.2983 13.3334 12.6665 13.3334ZM12.6665 14.6667C13.7711 14.6667 14.6665 13.7713 14.6665 12.6667C14.6665 11.5622 13.7711 10.6667 12.6665 10.6667C11.5619 10.6667 10.6665 11.5622 10.6665 12.6667C10.6665 13.7713 11.5619 14.6667 12.6665 14.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3332 2.66659C9.4127 2.66659 8.6665 3.41278 8.6665 4.33325V11.6666C8.6665 13.3234 7.32336 14.6666 5.6665 14.6666C4.00965 14.6666 2.6665 13.3234 2.6665 11.6666V6.66659C2.6665 6.2984 2.96498 5.99992 3.33317 5.99992C3.70136 5.99992 3.99984 6.2984 3.99984 6.66659V11.6666C3.99984 12.5871 4.74603 13.3333 5.6665 13.3333C6.58698 13.3333 7.33317 12.5871 7.33317 11.6666V4.33325C7.33317 2.6764 8.67632 1.33325 10.3332 1.33325C11.99 1.33325 13.3332 2.6764 13.3332 4.33325V8.66659C13.3332 9.03478 13.0347 9.33325 12.6665 9.33325C12.2983 9.33325 11.9998 9.03478 11.9998 8.66659V4.33325C11.9998 3.41278 11.2536 2.66659 10.3332 2.66659Z"
        fill="currentColor"
      />
      <path
        d="M2.75762 1.65375C3.01488 1.21275 3.65208 1.21275 3.90933 1.65375L5.08197 3.664C5.34123 4.10843 5.02065 4.66657 4.50612 4.66657H2.16083C1.64631 4.66657 1.32573 4.10843 1.58498 3.66399L2.75762 1.65375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CircledCrossIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9998 26.6667C21.8909 26.6667 26.6665 21.8911 26.6665 16.0001C26.6665 10.109 21.8909 5.33341 15.9998 5.33341C10.1088 5.33341 5.33317 10.109 5.33317 16.0001C5.33317 21.8911 10.1088 26.6667 15.9998 26.6667ZM15.9998 29.3334C23.3636 29.3334 29.3332 23.3639 29.3332 16.0001C29.3332 8.63628 23.3636 2.66675 15.9998 2.66675C8.63604 2.66675 2.6665 8.63628 2.6665 16.0001C2.6665 23.3639 8.63604 29.3334 15.9998 29.3334Z"
        fill="#B1B5C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.057 11.0573C11.5777 10.5366 12.4219 10.5366 12.9426 11.0573L15.9998 14.1145L19.057 11.0573C19.5777 10.5366 20.4219 10.5366 20.9426 11.0573C21.4633 11.578 21.4633 12.4222 20.9426 12.9429L17.8855 16.0001L20.9426 19.0573C21.4633 19.578 21.4633 20.4222 20.9426 20.9429C20.4219 21.4636 19.5777 21.4636 19.057 20.9429L15.9998 17.8857L12.9426 20.9429C12.4219 21.4636 11.5777 21.4636 11.057 20.9429C10.5363 20.4222 10.5363 19.578 11.057 19.0573L14.1142 16.0001L11.057 12.9429C10.5363 12.4222 10.5363 11.578 11.057 11.0573Z"
        fill="#B1B5C4"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.96875 9.5H16.0312"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 2.96875V16.0312"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Truck2Icon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7556 9.01358C17.7556 9.00784 17.755 9.00211 17.7547 8.99637C17.7542 8.98121 17.7532 8.96614 17.7514 8.95131C17.7506 8.94487 17.7495 8.93847 17.7484 8.93204C17.7461 8.91727 17.7433 8.90274 17.7398 8.88837C17.7384 8.88261 17.7369 8.87687 17.7353 8.87111C17.7308 8.85467 17.7255 8.83856 17.7194 8.82277C17.7184 8.82014 17.7178 8.81741 17.7167 8.81477L17.7134 8.80634L17.7126 8.80447L16.7618 6.42737C16.6813 6.22427 16.5415 6.05014 16.3606 5.92766C16.1797 5.80519 15.9661 5.74006 15.7477 5.74077H13.3867V5.19462C13.3867 5.04978 13.3291 4.91087 13.2267 4.80845C13.1243 4.70603 12.9854 4.64849 12.8405 4.64848H2.46386C2.17427 4.64881 1.89664 4.764 1.69187 4.96877C1.4871 5.17354 1.37191 5.45118 1.37158 5.74077V13.3867C1.37191 13.6763 1.4871 13.954 1.69187 14.1587C1.89664 14.3635 2.17427 14.4787 2.46386 14.479H3.35221C3.47334 14.948 3.74686 15.3634 4.12978 15.6599C4.5127 15.9565 4.9833 16.1174 5.46764 16.1174C5.95198 16.1174 6.42258 15.9565 6.8055 15.6599C7.18842 15.3634 7.46194 14.948 7.58307 14.479H11.5443C11.6655 14.948 11.939 15.3634 12.3219 15.6599C12.7048 15.9565 13.1754 16.1174 13.6598 16.1174C14.1441 16.1174 14.6147 15.9565 14.9976 15.6599C15.3805 15.3634 15.654 14.948 15.7752 14.479H16.6635C16.9531 14.4787 17.2308 14.3635 17.4355 14.1587C17.6403 13.954 17.7555 13.6763 17.7558 13.3867V9.01761C17.7558 9.01625 17.7556 9.01494 17.7556 9.01358ZM13.3867 6.83305H15.7477L16.403 8.47147H13.3867V6.83305ZM2.46386 5.74077H12.2944V10.1099H2.46386V5.74077ZM5.46764 15.0252C5.25161 15.0252 5.04043 14.9611 4.8608 14.8411C4.68118 14.7211 4.54118 14.5505 4.4585 14.3509C4.37583 14.1513 4.3542 13.9317 4.39635 13.7198C4.43849 13.5079 4.54252 13.3133 4.69528 13.1605C4.84804 13.0078 5.04266 12.9037 5.25455 12.8616C5.46643 12.8194 5.68605 12.8411 5.88564 12.9237C6.08523 13.0064 6.25582 13.1464 6.37584 13.326C6.49586 13.5057 6.55992 13.7168 6.55992 13.9329C6.55959 14.2225 6.4444 14.5001 6.23963 14.7049C6.03486 14.9096 5.75723 15.0248 5.46764 15.0252ZM13.6598 15.0252C13.4437 15.0252 13.2325 14.9611 13.0529 14.8411C12.8733 14.7211 12.7333 14.5505 12.6506 14.3509C12.5679 14.1513 12.5463 13.9317 12.5885 13.7198C12.6306 13.5079 12.7346 13.3133 12.8874 13.1605C13.0402 13.0078 13.2348 12.9037 13.4467 12.8616C13.6585 12.8194 13.8782 12.8411 14.0778 12.9237C14.2773 13.0064 14.4479 13.1464 14.568 13.326C14.688 13.5057 14.752 13.7168 14.752 13.9329C14.7517 14.2225 14.6365 14.5001 14.4317 14.7049C14.227 14.9096 13.9493 15.0248 13.6598 15.0252Z"
        fill="#475E8E"
      />
    </svg>
  );
}

export function RightArrowThin() {
  return (
    <svg
      width="2.1em"
      height="2.2em"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4243 17.7072C11.3024 17.5853 11.234 17.4199 11.234 17.2475C11.234 17.0751 11.3024 16.9097 11.4243 16.7877L16.166 12.0461H3.43191C3.25947 12.0461 3.0941 11.9776 2.97217 11.8557C2.85024 11.7338 2.78174 11.5684 2.78174 11.396C2.78174 11.2235 2.85024 11.0582 2.97217 10.9362C3.0941 10.8143 3.25947 10.7458 3.43191 10.7458H16.166L11.4243 6.00418C11.3639 5.94381 11.3161 5.87213 11.2834 5.79324C11.2507 5.71436 11.2339 5.62981 11.2339 5.54443C11.2339 5.45904 11.2507 5.3745 11.2834 5.29561C11.3161 5.21673 11.364 5.14506 11.4244 5.08469C11.4847 5.02431 11.5564 4.97642 11.6353 4.94375C11.7142 4.91108 11.7987 4.89427 11.8841 4.89427C11.9695 4.89428 12.054 4.9111 12.1329 4.94377C12.2118 4.97645 12.2835 5.02435 12.3439 5.08473L18.1954 10.9362C18.1975 10.9383 18.1992 10.9407 18.2013 10.9428C18.2142 10.956 18.2266 10.9695 18.2383 10.9837C18.2448 10.9917 18.2505 11.0001 18.2566 11.0083C18.2632 11.0171 18.27 11.0257 18.2762 11.0349C18.2825 11.0443 18.288 11.0542 18.2938 11.0639C18.2989 11.0724 18.3042 11.0807 18.3089 11.0895C18.3141 11.0992 18.3186 11.1093 18.3233 11.1193C18.3277 11.1285 18.3323 11.1377 18.3362 11.1472C18.3402 11.1568 18.3434 11.1666 18.3469 11.1764C18.3506 11.1866 18.3545 11.1968 18.3577 11.2072C18.3606 11.217 18.3628 11.2268 18.3653 11.2367C18.368 11.2474 18.371 11.258 18.3732 11.2689C18.3754 11.2803 18.3768 11.2917 18.3784 11.3031C18.3798 11.3127 18.3816 11.3221 18.3825 11.3318C18.3846 11.3531 18.3858 11.3745 18.3858 11.396C18.3858 11.4174 18.3846 11.4388 18.3825 11.4601C18.3816 11.4698 18.3798 11.4792 18.3784 11.4888C18.3768 11.5002 18.3754 11.5116 18.3732 11.523C18.371 11.5339 18.368 11.5445 18.3653 11.5553C18.3628 11.5651 18.3606 11.575 18.3577 11.5847C18.3545 11.5952 18.3506 11.6053 18.3469 11.6156C18.3434 11.6253 18.3402 11.6352 18.3362 11.6448C18.3323 11.6543 18.3277 11.6634 18.3233 11.6727C18.3186 11.6826 18.3141 11.6927 18.3089 11.7025C18.3042 11.7112 18.2989 11.7195 18.2938 11.728C18.288 11.7378 18.2825 11.7476 18.2762 11.757C18.2701 11.7662 18.2632 11.7749 18.2566 11.7837C18.2505 11.7918 18.2448 11.8003 18.2383 11.8082C18.2264 11.8227 18.2137 11.8364 18.2006 11.8499C18.1988 11.8517 18.1972 11.8538 18.1954 11.8557L12.3439 17.7072C12.2835 17.7676 12.2118 17.8155 12.1329 17.8482C12.054 17.8808 11.9695 17.8977 11.8841 17.8977C11.7987 17.8977 11.7141 17.8808 11.6353 17.8482C11.5564 17.8155 11.4847 17.7676 11.4243 17.7072Z"
        fill="#C8C8C8"
      />
    </svg>
  );
}

export function SmallCheckIcon() {
  return (
    <svg
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 2.5L4 5.5L8 1" stroke="white" />
    </svg>
  );
}

export function PinIcon2() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.429 1.69798C6.91212 1.69978 5.45788 2.30316 4.38529 3.37575C3.31269 4.44835 2.70932 5.90258 2.70752 7.41946C2.70752 12.315 7.90886 16.0128 8.13032 16.1678C8.21791 16.2289 8.32217 16.2617 8.429 16.2617C8.53583 16.2617 8.64008 16.2289 8.72767 16.1678C8.94913 16.0128 14.1505 12.315 14.1505 7.41946C14.1487 5.90258 13.5453 4.44835 12.4727 3.37575C11.4001 2.30316 9.94587 1.69978 8.429 1.69798ZM8.42938 5.33911C8.84087 5.33911 9.24312 5.46113 9.58526 5.68974C9.9274 5.91836 10.1941 6.24329 10.3515 6.62346C10.509 7.00363 10.5502 7.42196 10.4699 7.82554C10.3897 8.22912 10.1915 8.59984 9.90054 8.89081C9.60957 9.18178 9.23885 9.37993 8.83527 9.46021C8.43168 9.54049 8.01336 9.49928 7.63319 9.34181C7.25302 9.18434 6.92809 8.91767 6.69947 8.57553C6.47086 8.23339 6.34884 7.83114 6.34884 7.41965C6.34883 7.14643 6.40264 6.87588 6.5072 6.62345C6.61175 6.37103 6.765 6.14167 6.9582 5.94847C7.15139 5.75527 7.38075 5.60202 7.63318 5.49747C7.88561 5.39291 8.15615 5.3391 8.42938 5.33911Z"
        fill="#FE7224"
      />
    </svg>
  );
}

export function RightChevronIcon() {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11L7 6L1 1"
        stroke="#787878"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.79688 1.78027C7.82915 1.78249 5.94266 2.56515 4.55127 3.95654C3.15988 5.34793 2.37722 7.23443 2.375 9.20215V15.4613C2.37535 15.7696 2.49798 16.0651 2.71596 16.2831C2.93395 16.5011 3.22951 16.6237 3.53779 16.624H9.79688C11.7653 16.624 13.6531 15.8421 15.0449 14.4502C16.4368 13.0583 17.2188 11.1706 17.2188 9.20215C17.2188 7.23374 16.4368 5.34596 15.0449 3.95409C13.6531 2.56222 11.7653 1.78027 9.79688 1.78027ZM11.8749 11.2803H7.42173C7.26426 11.2803 7.11323 11.2177 7.00189 11.1064C6.89054 10.995 6.82798 10.844 6.82798 10.6865C6.82798 10.5291 6.89054 10.378 7.00189 10.2667C7.11323 10.1553 7.26426 10.0928 7.42173 10.0928H11.8749C12.0323 10.0928 12.1834 10.1553 12.2947 10.2667C12.406 10.378 12.4686 10.5291 12.4686 10.6865C12.4686 10.844 12.406 10.995 12.2947 11.1064C12.1834 11.2177 12.0323 11.2803 11.8749 11.2803ZM11.8749 8.90527H7.42173C7.26426 8.90527 7.11323 8.84272 7.00189 8.73137C6.89054 8.62002 6.82798 8.469 6.82798 8.31152C6.82798 8.15405 6.89054 8.00303 7.00189 7.89168C7.11323 7.78033 7.26426 7.71777 7.42173 7.71777H11.8749C12.0323 7.71777 12.1834 7.78033 12.2947 7.89168C12.406 8.00303 12.4686 8.15405 12.4686 8.31152C12.4686 8.469 12.406 8.62002 12.2947 8.73137C12.1834 8.84272 12.0323 8.90527 11.8749 8.90527Z"
        fill="#3371F5"
      />
    </svg>
  );
}

export function SmallDashedLine() {
  return (
    <svg
      width="1"
      height="13"
      viewBox="0 0 1 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="0.5" y1="2.18557e-08" x2="0.5" y2="3" stroke="#D6D6D6" />
      <line x1="0.5" y1="5" x2="0.5" y2="8" stroke="#D6D6D6" />
      <line x1="0.5" y1="10" x2="0.5" y2="13" stroke="#D6D6D6" />
    </svg>
  );
}

export function PackageIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1259 17L16.9849 30.6545"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2036 23.2863V10.7137C29.2036 10.5255 29.1536 10.3407 29.0588 10.1782C28.964 10.0157 28.8277 9.88128 28.6639 9.78869L17.5077 3.48299C17.3482 3.39283 17.1681 3.34546 16.9849 3.34546C16.8017 3.34546 16.6216 3.39283 16.4621 3.48299L5.3058 9.78869C5.142 9.88128 5.00572 10.0157 4.9109 10.1782C4.81608 10.3407 4.76611 10.5255 4.76611 10.7137V23.2863C4.76611 23.4745 4.81608 23.6592 4.9109 23.8218C5.00572 23.9843 5.142 24.1187 5.3058 24.2113L16.4621 30.517C16.6216 30.6071 16.8017 30.6545 16.9849 30.6545C17.1681 30.6545 17.3482 30.6071 17.5077 30.517L28.6639 24.2113C28.8277 24.1187 28.964 23.9843 29.0588 23.8218C29.1536 23.6592 29.2036 23.4745 29.2036 23.2863V23.2863Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0582 10.177L17.1259 17L4.9126 10.1755"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5107 19.7241V13.3491L11.1885 6.46387"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HourGlassIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.646 4.84375H25.3542C25.5581 4.84375 25.7575 4.90057 25.9271 5.00701C26.0967 5.11346 26.2289 5.26476 26.3069 5.44178C26.385 5.61879 26.4054 5.81357 26.3656 6.00149C26.3258 6.18941 26.2276 6.36203 26.0834 6.49751L6.91679 24.5025C6.77257 24.638 6.67435 24.8106 6.63456 24.9985C6.59477 25.1864 6.61519 25.3812 6.69325 25.5582C6.7713 25.7352 6.90348 25.8865 7.07306 25.993C7.24265 26.0994 7.44203 26.1563 7.646 26.1562H25.3542C25.5581 26.1563 25.7575 26.0994 25.9271 25.993C26.0967 25.8865 26.2289 25.7352 26.3069 25.5582C26.385 25.3812 26.4054 25.1864 26.3656 24.9985C26.3258 24.8106 26.2276 24.638 26.0834 24.5025L6.91679 6.49751C6.77257 6.36203 6.67435 6.18941 6.63456 6.00149C6.59477 5.81357 6.61519 5.61879 6.69325 5.44178C6.7713 5.26476 6.90348 5.11346 7.07306 5.00701C7.24265 4.90057 7.44203 4.84375 7.646 4.84375Z"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6875 21.3125H10.3125"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PathIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7812 28.875C27.4899 28.875 28.875 27.4899 28.875 25.7812C28.875 24.0726 27.4899 22.6875 25.7812 22.6875C24.0726 22.6875 22.6875 24.0726 22.6875 25.7812C22.6875 27.4899 24.0726 28.875 25.7812 28.875Z"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.28125 7.21875H21.6562C22.7503 7.21875 23.7995 7.65335 24.5731 8.42693C25.3467 9.20052 25.7812 10.2497 25.7812 11.3438C25.7812 12.4378 25.3467 13.487 24.5731 14.2606C23.7995 15.0342 22.7503 15.4687 21.6562 15.4688H9.28125C7.91373 15.4688 6.60222 16.012 5.63523 16.979C4.66825 17.946 4.125 19.2575 4.125 20.625C4.125 21.9925 4.66825 23.304 5.63523 24.271C6.60222 25.238 7.91373 25.7812 9.28125 25.7812H22.6875"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HouseIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.593 26.8115V20.6238C19.593 20.3503 19.4843 20.088 19.2909 19.8946C19.0976 19.7012 18.8352 19.5926 18.5617 19.5926H14.4367C14.1632 19.5926 13.9009 19.7012 13.7075 19.8946C13.5141 20.088 13.4055 20.3503 13.4055 20.6238V26.8115C13.4055 27.0849 13.2969 27.3472 13.1035 27.5406C12.9101 27.734 12.6479 27.8427 12.3744 27.8427L6.18763 27.8435C6.05219 27.8435 5.91808 27.8169 5.79295 27.7651C5.66781 27.7132 5.55412 27.6373 5.45834 27.5415C5.36257 27.4458 5.28659 27.3321 5.23476 27.2069C5.18293 27.0818 5.15625 26.9477 5.15625 26.8123V14.8935C5.15625 14.7499 5.18627 14.6078 5.24439 14.4764C5.30251 14.345 5.38744 14.2272 5.49374 14.1305L15.8055 4.75457C15.9954 4.58198 16.2427 4.48634 16.4993 4.48633C16.7558 4.48632 17.0032 4.58194 17.193 4.75453L27.5062 14.1305C27.6125 14.2272 27.6975 14.345 27.7556 14.4764C27.8137 14.6078 27.8438 14.7499 27.8438 14.8936V26.8123C27.8438 26.9477 27.8171 27.0818 27.7652 27.2069C27.7134 27.3321 27.6374 27.4458 27.5417 27.5415C27.4459 27.6373 27.3322 27.7132 27.2071 27.7651C27.0819 27.8169 26.9478 27.8435 26.8124 27.8435L20.6241 27.8427C20.3506 27.8427 20.0884 27.734 19.895 27.5406C19.7016 27.3472 19.593 27.0849 19.593 26.8115V26.8115Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HouseIcon2() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 12.5333V5.97739L14.3236 6.5716C14.6393 6.76103 15.0488 6.65866 15.2383 6.34294C15.4277 6.02722 15.3253 5.61771 15.0096 5.42828L11.6617 3.41951L9.10086 1.87665L9.10081 1.87663C8.91466 1.76447 8.77179 1.67839 8.65072 1.61367C8.62246 1.59786 8.59377 1.58316 8.56471 1.56957C8.46394 1.52039 8.3766 1.48766 8.28686 1.46789C8.09783 1.42623 7.90201 1.42623 7.71298 1.46789C7.62301 1.48771 7.53544 1.52056 7.43435 1.56995C7.40581 1.58332 7.37763 1.59776 7.34988 1.61327C7.22865 1.67803 7.08559 1.76423 6.89905 1.87662L6.89901 1.87663L4.33438 3.42182L0.990274 5.42828C0.674554 5.61771 0.572177 6.02722 0.761609 6.34294C0.951042 6.65866 1.36055 6.76103 1.67627 6.5716L2.66659 5.97741V12.5333C2.66659 13.2801 2.66659 13.6534 2.81191 13.9386C2.93974 14.1895 3.14372 14.3935 3.3946 14.5213C3.67981 14.6667 4.05318 14.6667 4.79992 14.6667L5.99992 14.6666V10.6666C5.99992 9.56206 6.89535 8.66663 7.99992 8.66663C9.10449 8.66663 9.99992 9.56206 9.99992 10.6666V14.6666L11.1999 14.6667C11.9467 14.6667 12.32 14.6667 12.6052 14.5213C12.8561 14.3935 13.0601 14.1895 13.1879 13.9386C13.3333 13.6534 13.3333 13.2801 13.3333 12.5333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CircleAndSquareIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00016 12C9.31387 12 12.0002 9.31375 12.0002 6.00004C12.0002 5.9009 11.9978 5.80232 11.993 5.70436C11.9834 5.506 12.1372 5.33337 12.3358 5.33337H13.3335C14.0699 5.33337 14.6668 5.93033 14.6668 6.66671V13.3334C14.6668 14.0698 14.0699 14.6667 13.3335 14.6667H6.66683C5.93045 14.6667 5.3335 14.0698 5.3335 13.3334V12.3356C5.3335 12.137 5.50612 11.9833 5.70448 11.9929C5.80244 11.9976 5.90102 12 6.00016 12Z"
        fill="currentColor"
      />
      <path
        d="M10.6668 6.00004C10.6668 8.57737 8.57749 10.6667 6.00016 10.6667C3.42283 10.6667 1.3335 8.57737 1.3335 6.00004C1.3335 3.42271 3.42283 1.33337 6.00016 1.33337C8.57749 1.33337 10.6668 3.42271 10.6668 6.00004Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LightningIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.76363 8.94297L9.00113 0.306432C9.41371 -0.264838 10.315 0.111266 10.1992 0.806358L9.33358 5.99997H12.6964C13.2403 5.99997 13.5553 6.61607 13.2369 7.05696L6.99936 15.6935C6.58677 16.2648 5.68546 15.8887 5.80131 15.1936L6.66691 9.99997H3.30408C2.76024 9.99997 2.44521 9.38386 2.76363 8.94297Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M29.2417 14.9719C29.2417 7.12168 22.8778 0.757812 15.0276 0.757812C7.17734 0.757812 0.813477 7.12168 0.813477 14.9719C0.813477 22.0665 6.01134 27.947 12.8066 29.0133V19.0807H9.19758V14.9719H12.8066V11.8404C12.8066 8.27796 14.9288 6.3102 18.1755 6.3102C19.7302 6.3102 21.3573 6.58782 21.3573 6.58782V10.0858H19.565C17.7993 10.0858 17.2485 11.1816 17.2485 12.3068V14.9719H21.1907L20.5605 19.0807H17.2485V29.0133C24.0438 27.947 29.2417 22.0665 29.2417 14.9719Z"
          fill="#2C435F"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="28.4282"
            height="28.4282"
            fill="white"
            transform="translate(0.813477 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function VKIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.81346 2.75253C0.758301 4.74724 0.758301 7.95868 0.758301 14.3797V15.5642C0.758301 21.9842 0.758301 25.1966 2.81346 27.1913C4.86862 29.186 8.17737 29.186 14.7929 29.186H16.0133C22.6279 29.186 25.9377 29.186 27.9928 27.1913C30.048 25.1966 30.048 21.9852 30.048 15.5642V14.3797C30.048 7.95963 30.048 4.74724 27.9928 2.75253C25.9377 0.757812 22.6289 0.757812 16.0133 0.757812H14.7929C8.17835 0.757812 4.86862 0.757812 2.81346 2.75253ZM6.55567 9.64163H8.69089C9.23665 9.64163 9.44168 9.87379 9.64671 10.448C10.6914 13.4008 12.4527 15.9821 13.1761 15.9821C13.4485 15.9821 13.5725 15.8608 13.5725 15.1908V12.1386C13.5236 11.2697 13.2108 10.8938 12.9792 10.6155C12.8362 10.4436 12.7241 10.3089 12.7241 10.1183C12.7241 9.88611 12.9281 9.64163 13.2669 9.64163H16.6235C17.0765 9.64163 17.2337 9.87663 17.2337 10.4035V14.5104C17.2337 14.9492 17.4299 15.1036 17.5657 15.1036C17.8371 15.1036 18.0636 14.9492 18.5615 14.4659C20.1002 12.7972 21.1859 10.2282 21.1859 10.2282C21.3216 9.92023 21.5725 9.64163 22.1153 9.64163H24.2505C24.8969 9.64163 25.0335 9.96476 24.8969 10.4035C24.6254 11.6117 22.0235 15.169 22.0235 15.169C21.797 15.5206 21.7062 15.6959 22.0235 16.091C22.1355 16.2433 22.3744 16.4706 22.6476 16.7304C22.9269 16.9962 23.2421 17.296 23.4939 17.5845C24.4116 18.5861 25.1029 19.4314 25.2952 20.0132C25.4719 20.5979 25.1663 20.8945 24.5561 20.8945H22.4199C21.848 20.8945 21.5603 20.5836 20.938 19.9113C20.6743 19.6264 20.3505 19.2766 19.9196 18.8581C18.6513 17.6726 18.1095 17.5191 17.7922 17.5191C17.3626 17.5191 17.2337 17.6375 17.2337 18.2298V20.089C17.2337 20.5979 17.0658 20.8945 15.7077 20.8945C13.4456 20.8945 10.9589 19.5612 9.19467 17.1012C6.54688 13.5003 5.82343 10.7769 5.82343 10.2282C5.82343 9.92023 5.94547 9.64163 6.55567 9.64163Z"
          fill="#2C435F"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="29.2897"
            height="28.4282"
            fill="white"
            transform="translate(0.758301 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TwitterIconLarge() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M9.34265 26.5211C20.3926 26.5211 26.4382 17.6334 26.4382 9.92839C26.4382 9.67853 26.4325 9.42312 26.421 9.17326C27.5971 8.34778 28.612 7.3253 29.4181 6.15388C28.3228 6.62685 27.1599 6.93575 25.9691 7.07002C27.2229 6.34057 28.1617 5.19463 28.6115 3.84464C27.4319 4.52312 26.142 5.00172 24.797 5.25994C23.8907 4.32531 22.6924 3.70647 21.3875 3.4991C20.0825 3.29173 18.7435 3.50739 17.5774 4.11273C16.4114 4.71807 15.4833 5.67937 14.9366 6.84802C14.3899 8.01666 14.2551 9.32755 14.553 10.578C12.1646 10.4617 9.8281 9.8595 7.69489 8.81049C5.56169 7.76149 3.67942 6.28908 2.17011 4.48872C1.40301 5.7724 1.16827 7.29142 1.51361 8.73705C1.85896 10.1827 2.75846 11.4464 4.02932 12.2715C3.07524 12.2421 2.14205 11.9928 1.30687 11.5441V11.6163C1.30601 12.9634 1.78584 14.2693 2.66479 15.3119C3.54374 16.3545 4.76756 17.0694 6.12822 17.3353C5.24441 17.57 4.31682 17.6042 3.41721 17.4352C3.80117 18.5938 4.5482 19.607 5.55405 20.3337C6.5599 21.0603 7.77439 21.464 9.02802 21.4885C6.89973 23.1111 4.27068 23.9912 1.5643 23.987C1.08434 23.9863 0.604862 23.9578 0.128418 23.9015C2.87781 25.6135 6.07609 26.5228 9.34265 26.5211Z"
          fill="#2C435F"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="29.2897"
            height="28.4282"
            fill="white"
            transform="translate(0.128418 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function InstagramIconLarge() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.0882 3.31746C19.0011 3.31746 19.4645 3.33412 21.0033 3.40075C22.4335 3.46182 23.2058 3.69502 23.7206 3.88936C24.4014 4.14477 24.8934 4.4557 25.4025 4.94986C25.9174 5.44958 26.232 5.92153 26.4952 6.58226C26.6954 7.08198 26.9356 7.8371 26.9986 9.21965C27.0672 10.7188 27.0844 11.1685 27.0844 14.9608C27.0844 18.7586 27.0672 19.2084 26.9986 20.702C26.9356 22.0901 26.6954 22.8396 26.4952 23.3394C26.232 24.0001 25.9116 24.4776 25.4025 24.9718C24.8877 25.4715 24.4014 25.7769 23.7206 26.0323C23.2058 26.2266 22.4278 26.4598 21.0033 26.5209C19.4588 26.5875 18.9954 26.6042 15.0882 26.6042C11.1753 26.6042 10.7119 26.5875 9.17306 26.5209C7.7429 26.4598 6.97061 26.2266 6.45575 26.0323C5.775 25.7769 5.28302 25.4659 4.77388 24.9718C4.25903 24.472 3.94439 24.0001 3.68124 23.3394C3.48102 22.8396 3.24075 22.0845 3.17783 20.702C3.10918 19.2028 3.09202 18.7531 3.09202 14.9608C3.09202 11.163 3.10918 10.7132 3.17783 9.21965C3.24075 7.83155 3.48102 7.08198 3.68124 6.58226C3.94439 5.92153 4.26475 5.44403 4.77388 4.94986C5.28874 4.45015 5.775 4.14477 6.45575 3.88936C6.97061 3.69502 7.74862 3.46182 9.17306 3.40075C10.7119 3.33412 11.1753 3.31746 15.0882 3.31746ZM15.0882 0.757812C11.1124 0.757812 10.6147 0.77447 9.05292 0.841098C7.49691 0.907727 6.42715 1.15203 5.5004 1.50183C4.53362 1.86829 3.71557 2.35135 2.90323 3.14534C2.08518 3.93378 1.58749 4.72777 1.20993 5.66057C0.849525 6.56561 0.597817 7.59835 0.529169 9.1086C0.460521 10.63 0.443359 11.113 0.443359 14.9719C0.443359 18.8308 0.460521 19.3139 0.529169 20.8297C0.597817 22.3399 0.849525 23.3782 1.20993 24.2777C1.58749 25.2161 2.08518 26.0101 2.90323 26.7985C3.71557 27.5869 4.53362 28.0755 5.49468 28.4365C6.42715 28.7863 7.49119 29.0306 9.0472 29.0972C10.6089 29.1638 11.1066 29.1805 15.0825 29.1805C19.0583 29.1805 19.556 29.1638 21.1178 29.0972C22.6738 29.0306 23.7435 28.7863 24.6703 28.4365C25.6313 28.0755 26.4494 27.5869 27.2617 26.7985C28.074 26.0101 28.5775 25.2161 28.9493 24.2833C29.3097 23.3782 29.5614 22.3455 29.6301 20.8352C29.6987 19.3194 29.7159 18.8364 29.7159 14.9775C29.7159 11.1186 29.6987 10.6355 29.6301 9.1197C29.5614 7.60946 29.3097 6.57116 28.9493 5.67167C28.5889 4.72777 28.0912 3.93378 27.2732 3.14534C26.4608 2.3569 25.6428 1.86829 24.6817 1.50738C23.7492 1.15758 22.6852 0.913279 21.1292 0.846651C19.5617 0.77447 19.064 0.757812 15.0882 0.757812Z"
          fill="#2C435F"
        />
        <path
          d="M15.0881 7.67041C10.9349 7.67041 7.56543 10.9408 7.56543 14.9718C7.56543 19.0028 10.9349 22.2732 15.0881 22.2732C19.2413 22.2732 22.6107 19.0028 22.6107 14.9718C22.6107 10.9408 19.2413 7.67041 15.0881 7.67041ZM15.0881 19.708C12.3936 19.708 10.2084 17.587 10.2084 14.9718C10.2084 12.3566 12.3936 10.2356 15.0881 10.2356C17.7825 10.2356 19.9678 12.3566 19.9678 14.9718C19.9678 17.587 17.7825 19.708 15.0881 19.708Z"
          fill="#2C435F"
        />
        <path
          d="M24.6643 7.38183C24.6643 8.32574 23.8749 9.08641 22.9081 9.08641C21.9356 9.08641 21.1519 8.32018 21.1519 7.38183C21.1519 6.43792 21.9413 5.67725 22.9081 5.67725C23.8749 5.67725 24.6643 6.44348 24.6643 7.38183Z"
          fill="#2C435F"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="29.2897"
            height="28.4282"
            fill="white"
            transform="translate(0.443359 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CrossIcon3() {
  return (
    <svg
      width="2em"
      height="1.9em"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.91946 4.56437C5.21897 4.26891 5.70457 4.26891 6.00408 4.56437L10.0634 8.56885L14.1228 4.56437C14.4223 4.26891 14.9079 4.26891 15.2074 4.56437C15.5069 4.85983 15.5069 5.33887 15.2074 5.63433L11.1481 9.63881L15.2074 13.6433C15.5069 13.9387 15.5069 14.4178 15.2074 14.7132C14.9079 15.0087 14.4223 15.0087 14.1228 14.7132L10.0634 10.7088L6.00408 14.7132C5.70457 15.0087 5.21897 15.0087 4.91946 14.7132C4.61995 14.4178 4.61995 13.9387 4.91946 13.6433L8.97881 9.63881L4.91946 5.63433C4.61995 5.33887 4.61995 4.85983 4.91946 4.56437Z"
        fill="#777E91"
      />
    </svg>
  );
}

export function ToastSuccessIconSmall() {
  return (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.944336"
        y="0.554688"
        width="44.6222"
        height="41.2678"
        rx="10"
        fill="#E3F9DD"
      />
      <ellipse
        cx="23.2555"
        cy="21.4641"
        rx="12.2711"
        ry="12.1052"
        fill="#4ECE27"
      />
      <path
        d="M18.5 22L21.5 25L27.5 19"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function ToastSuccessIconLarge() {
  return (
    <svg
      width="65"
      height="59"
      viewBox="0 0 65 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.833496"
        y="0.201416"
        width="63.4667"
        height="58.6957"
        rx="15"
        fill="#E3F9DD"
      />
      <ellipse
        cx="32.5666"
        cy="29.9405"
        rx="17.4533"
        ry="17.2174"
        fill="#4ECE27"
      />
      <path
        d="M25.8232 29.9406L30.3188 34.3754L39.3099 25.5059"
        stroke="white"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function ToastErrorIconSmall() {
  return (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.944336"
        y="0.554688"
        width="44.6222"
        height="41.2678"
        rx="10"
        fill="#FFE0E0"
      />
      <ellipse
        cx="23.2555"
        cy="21.4641"
        rx="12.2711"
        ry="12.1052"
        fill="#F92929"
      />
      <path
        d="M23.96 23.24H22.328L21.896 19V15.8H24.376V19L23.96 23.24ZM24.504 25.848C24.504 26.2213 24.3707 26.5413 24.104 26.808C23.8373 27.0747 23.5173 27.208 23.144 27.208C22.7707 27.208 22.4507 27.0747 22.184 26.808C21.9173 26.5413 21.784 26.2213 21.784 25.848C21.784 25.4747 21.9173 25.1547 22.184 24.888C22.4507 24.6213 22.7707 24.488 23.144 24.488C23.5173 24.488 23.8373 24.6213 24.104 24.888C24.3707 25.1547 24.504 25.4747 24.504 25.848Z"
        fill="white"
      />
    </svg>
  );
}
export function ToastErrorIconLarge() {
  return (
    <svg
      width="65"
      height="60"
      viewBox="0 0 65 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.833496"
        y="0.434814"
        width="63.4667"
        height="58.6957"
        rx="15"
        fill="#FFE0E0"
      />
      <ellipse
        cx="32.5666"
        cy="30.1739"
        rx="17.4533"
        ry="17.2174"
        fill="#F92929"
      />
      <path
        d="M33.8865 32.3H31.8465L31.3065 27V23H34.4065V27L33.8865 32.3ZM34.5665 35.56C34.5665 36.0267 34.3999 36.4267 34.0665 36.76C33.7332 37.0933 33.3332 37.26 32.8665 37.26C32.3999 37.26 31.9999 37.0933 31.6665 36.76C31.3332 36.4267 31.1665 36.0267 31.1665 35.56C31.1665 35.0933 31.3332 34.6933 31.6665 34.36C31.9999 34.0267 32.3999 33.86 32.8665 33.86C33.3332 33.86 33.7332 34.0267 34.0665 34.36C34.3999 34.6933 34.5665 35.0933 34.5665 35.56Z"
        fill="white"
      />
    </svg>
  );
}

export function ToastWarnIconSmall() {
  return (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.944336"
        y="0.554688"
        width="44.6222"
        height="41.2678"
        rx="10"
        fill="#FFF4D6"
      />
      <path
        d="M20.4369 9.21364C21.6056 7.29239 24.3944 7.29239 25.5631 9.21363L36.6813 27.4918C37.8974 29.491 36.4582 32.0508 34.1182 32.0508H11.8818C9.54176 32.0508 8.10262 29.491 9.3187 27.4918L20.4369 9.21364Z"
        fill="#FFAA00"
      />
      <path
        d="M23.7056 24.24H22.0736L21.6416 20V16.8H24.1216V20L23.7056 24.24ZM24.2496 26.848C24.2496 27.2213 24.1163 27.5413 23.8496 27.808C23.5829 28.0747 23.2629 28.208 22.8896 28.208C22.5163 28.208 22.1963 28.0747 21.9296 27.808C21.6629 27.5413 21.5296 27.2213 21.5296 26.848C21.5296 26.4747 21.6629 26.1547 21.9296 25.888C22.1963 25.6213 22.5163 25.488 22.8896 25.488C23.2629 25.488 23.5829 25.6213 23.8496 25.888C24.1163 26.1547 24.2496 26.4747 24.2496 26.848Z"
        fill="white"
      />
    </svg>
  );
}

export function ToastWarnIconLarge() {
  return (
    <svg
      width="67"
      height="62"
      viewBox="0 0 67 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="66.1333" height="62" rx="15" fill="#FFF4D6" />
      <path
        d="M30.9169 12.4802C32.0855 10.559 34.8743 10.559 36.043 12.4802L51.8262 38.4275C53.0423 40.4268 51.6032 42.9866 49.2631 42.9866H17.6967C15.3567 42.9866 13.9176 40.4268 15.1336 38.4275L30.9169 12.4802Z"
        fill="#FFAA00"
      />
      <path
        d="M34.2867 32.3H32.2467L31.7067 27V23H34.8067V27L34.2867 32.3ZM34.9667 35.56C34.9667 36.0267 34.8 36.4267 34.4667 36.76C34.1333 37.0933 33.7333 37.26 33.2667 37.26C32.8 37.26 32.4 37.0933 32.0667 36.76C31.7333 36.4267 31.5667 36.0267 31.5667 35.56C31.5667 35.0933 31.7333 34.6933 32.0667 34.36C32.4 34.0267 32.8 33.86 33.2667 33.86C33.7333 33.86 34.1333 34.0267 34.4667 34.36C34.8 34.6933 34.9667 35.0933 34.9667 35.56Z"
        fill="white"
      />
    </svg>
  );
}
export function ToastInfoIconLarge() {
  return (
    <svg
      width="65"
      height="60"
      viewBox="0 0 65 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.833496"
        y="0.434814"
        width="63.4667"
        height="58.6957"
        rx="15"
        fill="#ECF4FF"
      />
      <ellipse
        cx="32.5666"
        cy="30.1739"
        rx="17.4533"
        ry="17.2174"
        fill="#006CFF"
      />
      <path
        d="M33.8865 32.3H31.8465L31.3065 27V23H34.4065V27L33.8865 32.3ZM34.5665 35.56C34.5665 36.0267 34.3999 36.4267 34.0665 36.76C33.7332 37.0933 33.3332 37.26 32.8665 37.26C32.3999 37.26 31.9999 37.0933 31.6665 36.76C31.3332 36.4267 31.1665 36.0267 31.1665 35.56C31.1665 35.0933 31.3332 34.6933 31.6665 34.36C31.9999 34.0267 32.3999 33.86 32.8665 33.86C33.3332 33.86 33.7332 34.0267 34.0665 34.36C34.3999 34.6933 34.5665 35.0933 34.5665 35.56Z"
        fill="white"
      />
    </svg>
  );
}
export function ToastInfoIconSmall() {
  return (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.94458"
        y="0.554688"
        width="44.6222"
        height="41.2678"
        rx="10"
        fill="#ECF4FF"
      />
      <ellipse
        cx="23.2555"
        cy="21.4641"
        rx="12.2711"
        ry="12.1052"
        fill="#006CFF"
      />
      <path
        d="M23.96 23.24H22.328L21.896 19V15.8H24.376V19L23.96 23.24ZM24.504 25.848C24.504 26.2213 24.3707 26.5413 24.104 26.808C23.8373 27.0747 23.5173 27.208 23.144 27.208C22.7707 27.208 22.4507 27.0747 22.184 26.808C21.9173 26.5413 21.784 26.2213 21.784 25.848C21.784 25.4747 21.9173 25.1547 22.184 24.888C22.4507 24.6213 22.7707 24.488 23.144 24.488C23.5173 24.488 23.8373 24.6213 24.104 24.888C24.3707 25.1547 24.504 25.4747 24.504 25.848Z"
        fill="white"
      />
    </svg>
  );
}
